// extracted by mini-css-extract-plugin
export var dropdownButton = "_1y-0";
export var fullWidthDropdownButton = "_1y-1";
export var icon = "_1y-3";
export var iconPlaceholder = "_1y-2";
export var menuItemRow = "_1y-5";
export var shortcutContainer = "_1y-4";